export const MEDIA_FORMATS = [
  { id: 'yt_dedicated', label: 'YT Dedicated', color: '#ff3b30', legacy: ['dedicated'] },
  { id: 'yt_integration', label: 'YT Integration', color: '#ff3b30', legacy: ['shoutout'] },
  { id: 'yt_vod', label: 'YT VOD', color: '#ff3b30', legacy: ['streaming+vod'] },
  { id: 'yt_highlight', label: 'YT Highlight', color: '#ff3b30', legacy: [] },
  { id: 'yt_short', label: 'YT Short', color: '#ff3b30', legacy: ['youtubeshort'] },
  { id: 'yt_stream', label: 'YT Stream', color: '#ff3b30', legacy: ['streaming'] },
  { id: 'yt_community_post', label: 'YT Community Post', color: '#ff3b30', legacy: [] },
  { id: 'tiktok_live', label: 'TikTok Live', color: '#111', legacy: [] },
  { id: 'tiktok_post', label: 'TikTok Post', color: '#111', legacy: ['tiktok'] },
  { id: 'tiktok_story', label: 'TikTok Story', color: '#111', legacy: [] },
  { id: 'spark_code', label: 'Spark Code', color: '#111', legacy: [] },
  { id: 'twitch_stream', label: 'Twitch Stream', color: '#6f42c1', legacy: [] },
  { id: 'kick_stream', label: 'Kick Stream', color: '#49e16f', legacy: [] },
  { id: 'ig_post', label: 'IG Post', color: '#ff4fd8', legacy: ['instapost', 'socialpost'] },
  { id: 'ig_story', label: 'IG Story', color: '#ff4fd8', legacy: ['instastory'] },
  { id: 'ig_reel', label: 'IG Reel', color: '#ff4fd8', legacy: ['instareel'] },
  { id: 'tweet', label: 'Tweet (X)', color: '#4ea3ff', legacy: ['tweet'] },
  { id: 'retweet', label: 'Re-Tweet (X)', color: '#4ea3ff', legacy: [] },
  { id: 'facebook_post', label: 'Facebook Post', color: '#1e5eff', legacy: [] },
  { id: 'facebook_story', label: 'Facebook Story', color: '#1e5eff', legacy: [] },
  { id: 'discord_post', label: 'Discord Post', color: '#6f42c1', legacy: [] },
  { id: 'mediabuy', label: 'Media Buy', color: '#7fe77f', legacy: ['mediabuy', 'shoutbuy', 'dedibuy'] },
  { id: 'package', label: 'Package', color: '#2f7a44', legacy: [] },
  { id: 'other', label: 'Other', color: '#999', legacy: ['other'] },
];

export const REQUIRED_DELIVERABLES_BY_FORMAT = {
  yt_dedicated: [
    { key: 'creative_url', label: 'Video Link', inputType: 'link', description: 'Final public YouTube video link.' },
    { key: 'performance_screenshot', label: 'Performance Screenshot', inputType: 'file', description: 'Screenshot of YouTube analytics.' },
  ],
  yt_integration: [
    { key: 'creative_url', label: 'Video Link', inputType: 'link', description: 'Final public YouTube video link.' },
    { key: 'integration_timestamp', label: 'Integration Timestamp', inputType: 'text', description: 'Timestamp of the integration segment.' },
    { key: 'performance_screenshot', label: 'Performance Screenshot', inputType: 'file', description: 'Screenshot of YouTube analytics.' },
  ],
  yt_vod: [
    { key: 'creative_url', label: 'Video Link', inputType: 'link', description: 'Final public YouTube video link.' },
    { key: 'performance_screenshot', label: 'Performance Screenshot', inputType: 'file', description: 'Screenshot of YouTube analytics.' },
  ],
  yt_highlight: [
    { key: 'creative_url', label: 'Highlight Link', inputType: 'link', description: 'Final public highlight link.' },
    { key: 'performance_screenshot', label: 'Performance Screenshot', inputType: 'file', description: 'Screenshot of YouTube analytics.' },
  ],
  yt_short: [
    { key: 'creative_url', label: 'Short Link', inputType: 'link', description: 'Final public YouTube short link.' },
    { key: 'performance_screenshot', label: 'Performance Screenshot', inputType: 'file', description: 'Screenshot of YouTube analytics.' },
  ],
  yt_stream: [
    { key: 'creative_url', label: 'Stream/VOD Link', inputType: 'link', description: 'Final public stream or VOD link.' },
    { key: 'performance_screenshot', label: 'Performance Screenshot', inputType: 'file', description: 'Screenshot of stream analytics.' },
  ],
  yt_community_post: [
    { key: 'creative_url', label: 'Post Link', inputType: 'link', description: 'Final YouTube community post link.' },
    { key: 'proof_screenshot', label: 'Post Screenshot', inputType: 'file', description: 'Screenshot proving publication.' },
  ],
  tiktok_post: [
    { key: 'creative_url', label: 'TikTok Link', inputType: 'link', description: 'Final public TikTok link.' },
    { key: 'performance_screenshot', label: 'Performance Screenshot', inputType: 'file', description: 'Screenshot of TikTok analytics.' },
  ],
  tiktok_story: [
    { key: 'proof_screenshot', label: 'Story Screenshot', inputType: 'file', description: 'Screenshot proving story publication.' },
  ],
  tiktok_live: [
    { key: 'proof_screenshot', label: 'Live Screenshot', inputType: 'file', description: 'Screenshot of live stream proof.' },
    { key: 'performance_screenshot', label: 'Performance Screenshot', inputType: 'file', description: 'Screenshot of TikTok live analytics.' },
  ],
  ig_post: [
    { key: 'creative_url', label: 'Post Link', inputType: 'link', description: 'Final public Instagram post link.' },
    { key: 'performance_screenshot', label: 'Performance Screenshot', inputType: 'file', description: 'Screenshot of Instagram insights.' },
  ],
  ig_story: [
    { key: 'proof_screenshot', label: 'Story Screenshot', inputType: 'file', description: 'Screenshot proving story publication.' },
    { key: 'performance_screenshot', label: 'Performance Screenshot', inputType: 'file', description: 'Screenshot of Instagram insights.' },
  ],
  ig_reel: [
    { key: 'creative_url', label: 'Reel Link', inputType: 'link', description: 'Final public Instagram reel link.' },
    { key: 'performance_screenshot', label: 'Performance Screenshot', inputType: 'file', description: 'Screenshot of Instagram insights.' },
  ],
  twitch_stream: [
    { key: 'creative_url', label: 'Stream Link', inputType: 'link', description: 'Final stream/VOD link.' },
    { key: 'performance_screenshot', label: 'Performance Screenshot', inputType: 'file', description: 'Screenshot of Twitch analytics.' },
  ],
  kick_stream: [
    { key: 'creative_url', label: 'Stream Link', inputType: 'link', description: 'Final stream/VOD link.' },
    { key: 'performance_screenshot', label: 'Performance Screenshot', inputType: 'file', description: 'Screenshot of Kick analytics.' },
  ],
  tweet: [
    { key: 'creative_url', label: 'Post Link', inputType: 'link', description: 'Final public X post link.' },
    { key: 'proof_screenshot', label: 'Post Screenshot', inputType: 'file', description: 'Screenshot proving publication.' },
  ],
  retweet: [
    { key: 'creative_url', label: 'Repost Link', inputType: 'link', description: 'Final public X repost link.' },
  ],
  facebook_post: [
    { key: 'creative_url', label: 'Post Link', inputType: 'link', description: 'Final public Facebook post link.' },
    { key: 'proof_screenshot', label: 'Post Screenshot', inputType: 'file', description: 'Screenshot proving publication.' },
  ],
  facebook_story: [
    { key: 'proof_screenshot', label: 'Story Screenshot', inputType: 'file', description: 'Screenshot proving story publication.' },
  ],
  discord_post: [
    { key: 'proof_screenshot', label: 'Post Screenshot', inputType: 'file', description: 'Screenshot proving Discord post publication.' },
  ],
  spark_code: [
    { key: 'creative_url', label: 'Post Link', inputType: 'link', description: 'Final public post link.' },
    { key: 'proof_screenshot', label: 'Campaign Screenshot', inputType: 'file', description: 'Screenshot proving Spark Code delivery.' },
  ],
  mediabuy: [
    { key: 'proof_screenshot', label: 'Proof Screenshot', inputType: 'file', description: 'Proof of delivered media buy.' },
  ],
  package: [
    { key: 'proof_screenshot', label: 'Proof Screenshot', inputType: 'file', description: 'Proof of delivered package.' },
  ],
  other: [
    { key: 'proof_screenshot', label: 'Proof Screenshot', inputType: 'file', description: 'Proof of delivery.' },
  ],
};

const legacyToCanonical = new Map();
const mediaFormatById = new Map();
MEDIA_FORMATS.forEach((item) => {
  const canonicalId = String(item.id || '').toLowerCase();
  mediaFormatById.set(canonicalId, item);
  (item.legacy || []).forEach((legacy) => {
    legacyToCanonical.set(String(legacy || '').toLowerCase(), item.id);
  });
  legacyToCanonical.set(canonicalId, item.id);
  legacyToCanonical.set(canonicalId.replace(/_/g, ' '), item.id);
});

export const canonicalizeMediaFormat = (rawFormat) => {
  const normalized = String(rawFormat || '').trim().toLowerCase();
  if (!normalized) return 'other';
  return legacyToCanonical.get(normalized) || normalized;
};

export const getMediaFormatLabel = (rawFormat) => {
  const original = String(rawFormat || '').trim();
  if (!original) return '';

  const canonicalFormat = canonicalizeMediaFormat(original);
  const mediaFormat = mediaFormatById.get(String(canonicalFormat || '').toLowerCase());

  return mediaFormat?.label || original;
};

export const getRequiredDeliverablesForFormat = (rawFormat) => {
  const canonicalFormat = canonicalizeMediaFormat(rawFormat);
  return {
    canonicalFormat,
    requirements: REQUIRED_DELIVERABLES_BY_FORMAT[canonicalFormat] || REQUIRED_DELIVERABLES_BY_FORMAT.other || [],
  };
};
